import { apiHelpers } from '../utils/helpers';
import { keysToCamelCase, keysToSnakeCase } from '../../../ui-lottery/src/utils/object_utils';
import * as endpoints from './endpoints';
import SecurityHelper from '../utils/security';

const { post, getWithAuth, postWithAuth, putWithAuth } = apiHelpers(SecurityHelper.getTokenHeaders);
const {
  getWithAuth: getApi,
  postWithAuth: postApi,
  putWithAuth: putApi,
  removeWithAuth: removeApi
} = apiHelpers(SecurityHelper.getApiKeyHeaders);

// Using the key endpoint and setting "id" to the generate action. Small hack
export const generateApiKey = () => postWithAuth(endpoints.keyEndpoint('generate'), {});

// Authentication
export const login = async (params) => {
  let response;

  try {
    // Fetch external account data for the user; login using email and password
    response = await post(endpoints.loginEndpoint(), params);
    const { account, access_token } = response.data;
    SecurityHelper.token(access_token);

    // Fetch the developers apiKey data; Uses the token received from the login above
    response = await getWithAuth(endpoints.keysEndpoint());
    const apiKey = keysToCamelCase(response.data.api_key);
    const isDeveloper = apiKey.apiKey !== '';
    const user = {
      loggedIn: true,
      isDeveloper,
      isTier1Developer: isDeveloper && apiKey.tier1Access,
      isTier2Developer: isDeveloper && apiKey.tier2Access,
      account: keysToCamelCase(account),
      apiKey
    };

    SecurityHelper.user(user);
    SecurityHelper.apiKey(apiKey.apiKey);

    return { data: user };
  }
 catch (e) {
    SecurityHelper.clearData();

    // MFA enabled?
    if (e.response && e.response.status === 400 && e.response.data.error === 'mfa') {
      throw new Error('mfa');
    }

    throw new Error('unauthorized');
  }
};

// Organizations
export const fetchOrganizations = () => getWithAuth(endpoints.orgsEndpoint());

// Assets
export const fetchAssets = (params) => getWithAuth(endpoints.assetsEndpoint(), { params });

// Activities
export const fetchActivities = (params) => getWithAuth(endpoints.activitiesEndpoint(), { params });

// Either RecArea or Facility
export const fetchAsset = (type, id, params) => getApi(endpoints.assetApiEndpoint(type, id), { params });

// Events
export const fetchEvents = (assetType, assetId, params) => getApi(endpoints.eventApiEndpoint(assetType, assetId), { params });

// Generic Resource Calls
export const createResource = (url, data, options = {}) => postApi(endpoints.api(url), data, options);
export const updateResource = (url, data, options = {}) => putApi(endpoints.api(url), data, options);
export const deleteResource = (url) => removeApi(endpoints.api(url));

// Admin Calls
export const getAccount = (params) => getWithAuth(endpoints.accountEndpoint(), { params });
export const enableDeveloperAccess = (accountId) => postWithAuth(endpoints.accountEndpointWithId(accountId), {});
export const updateAccount = (details) => putWithAuth(
  endpoints.accountEndpointWithId(details.externalId),
  keysToSnakeCase(details)
);
